import { Component, OnInit, Inject, Optional, Input, SimpleChanges } from '@angular/core';
import { AuthService } from '../app-services/auth.service';
import { FacebookPixelEventTrackerService } from '../app-services/facebookpixeleventtracker.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  public emailErrors;
  public passwordErrors;
  public termsAndConditions = false;
  public privacyPolicy = false;
  public cookiePolicy = false;
  public tncMessage;
  public ppMessage;
  public cpMessage;

  // hide = true;
  constructor(private authService: AuthService,
    private facebookEventService: FacebookPixelEventTrackerService,
    private router: Router,
    @Optional() public dialogRef: MatDialogRef<RegisterComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  public onSubmit(value: any) {

    this.emailErrors = '';
    this.passwordErrors = '';

    // first check if all the terms and conditions have been agreed to
    if (this.termsAndConditions === false) {
      this.tncMessage = 'You must accept our terms and conditions to use this service.';
    }
    if (this.privacyPolicy === false) {
      this.ppMessage = 'You must accept our privacy policy to use this service.';
    }
    if (this.cookiePolicy === false) {
      this.cpMessage = 'You must accept our cookie policy to use this service.';
    }

    if (this.cookiePolicy === true && this.privacyPolicy === true && this.termsAndConditions === true) {

    this.authService.register(value).subscribe(res => {
      this.authService.setTokenAndForward(res, true);

        // have facebook register the event
        this.facebookEventService.trackEvent('no properties for now');

        // close the modal if open
        if (this.dialogRef !== null) {
          this.dialogRef.close();
        }

        // if we have data send it to be added to the db
        if (this.data !== null && typeof this.data.netWorthRowAmount !== 'undefined') {
          this.authService.prefillUserGoal(this.data).subscribe( bla =>
            this.router.navigate(['/networth'])
          );
        } else {
          this.router.navigate(['/networth']);
        }
    },
    error => {

        if (error.status === 403) {

        } else if (error.status === 422) {
          if (error.json().error.errors.email) {
            this.emailErrors = error.json().error.errors.email[0];
          }
          if (error.json().error.errors.password) {
            this.passwordErrors = error.json().error.errors.password[0];
          }
        }else if (error.status === 500) {

          if (error.json().error.code === '23000') {
            this.emailErrors = 'This email has already been registered.';
          }
        }
      });
    }
  }
}




// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/register/register.component.ts